import { ClientValidationContext } from './validation-client-validators';
import { RuleSet } from './validation-rules.service';

export type CustomValidatorFn = (value: any, ctx: ClientValidationContext, rule: RuleSet) => boolean;

const EMAIL_REGEX = /^([Nn][Oo][Nn][Ee]|[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,})$/;
const PHONE_REGEX = /^\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/;
const SSN_REGEX = /^\d{3}-?\d{2}-?\d{4}$/;
const ZIP_REGEX = /^\d{5}(-?\d{4})?$/;

const hasNoDigits = (value: any): boolean => String(value).replace(/\D/g, '').length === 0;

const ValidateEmail: CustomValidatorFn = (value) => {
    if (value == null || String(value).trim() === '') return true;
    return EMAIL_REGEX.test(String(value).trim());
};

const ValidatePhone: CustomValidatorFn = (value) => {
    if (value == null || String(value).trim() === '' || hasNoDigits(value)) return true;
    return PHONE_REGEX.test(String(value).trim());
};

const ValidateSSN: CustomValidatorFn = (value) => {
    if (value == null || String(value).trim() === '' || hasNoDigits(value)) return true;
    return SSN_REGEX.test(String(value).trim());
};

const ValidateZip: CustomValidatorFn = (value) => {
    if (value == null || String(value).trim() === '' || hasNoDigits(value)) return true;
    return ZIP_REGEX.test(String(value).trim());
};

const NonNegativeNumber: CustomValidatorFn = (value) => {
    if (value == null || value === '') return true;
    const n = Number(value);
    return !isNaN(n) && n >= 0;
};

const isMedicaidPlan = (dto: any): boolean => {
    if (!dto) return false;
    const name = dto.policyplanname ?? dto.PolicyPlanName ?? dto.planName ?? dto.PlanName ?? '';
    return String(name).toLowerCase().includes('medicaid');
};

const ValidateInsuredIdLength10: CustomValidatorFn = (value, ctx) => {
    if (value == null || String(value).trim() === '') return true;
    if (!isMedicaidPlan(ctx?.dto)) return true;
    const v = String(value).trim();
    if (v.charAt(0).toLowerCase() !== 'm') return true;
    return v.length === 10;
};

const ValidateInsuredIdLength11: CustomValidatorFn = (value, ctx) => {
    if (value == null || String(value).trim() === '') return true;
    if (!isMedicaidPlan(ctx?.dto)) return true;
    const v = String(value).trim();
    if (v.charAt(0).toLowerCase() === 'm') return true;
    return v.length === 11;
};

export const CUSTOM_VALIDATORS: Record<string, CustomValidatorFn> = {
    ValidateEmail,
    ValidatePhone,
    ValidateSSN,
    ValidateZip,
    NonNegativeNumber,
    ValidateInsuredIdLength10,
    ValidateInsuredIdLength11,
};
